import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from 'src/app/order.service';
import { Store } from 'src/app/models/store';
import { RedeemConfirmationDialogComponent } from './redeem-confirmation-dialog/redeem-confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-redeem',
  templateUrl: './redeem.component.html',
  styleUrls: ['./redeem.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RedeemComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(private route: ActivatedRoute,
    private orderService: OrderService,
    private router: Router,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef) { }

  offerId;
  offerItem;
  store;
  redeemAmount;
  isLoading = true;
  hash
  balance
  useNow:boolean=false;
  orderHash: any;
  storeOffer: any;
  uiUx: boolean;
  storeId: any;

  ngOnInit() {
    this.hash = this.route.snapshot.paramMap.get('hash');
    this.offerId = this.route.snapshot.paramMap.get('offerId');
    this.storeId = localStorage.getItem('currentStore');

    forkJoin({
      offer: this.orderService.getOfferItemWithHash(this.hash, this.offerId),
      store: this.orderService.getStoreInfo(this.storeId)
    }).pipe(takeUntil(this.destroy$)).subscribe(({ offer, store }) => {
      this.offerItem = offer;
      this.store = Object.assign(new Store(), store);
      this.uiUx = this.store.feature_flag.stand_alone_gift;
      this.balance = offer.total_list_price - offer.redeemed_amount;
      this.redeemAmount = 0.00;
      this.isLoading = false;
      this.cdr.markForCheck();
    })
  }


  decrement() {
    if (this.redeemAmount > 0 && (this.redeemAmount - 5) > 0) {
      this.redeemAmount = this.redeemAmount - 5;
    }
  }

  increment() {
    if (this.redeemAmount < this.balance && this.balance > 0) {
      this.redeemAmount = this.redeemAmount + 5;
    }
  }

  get instoreEnabled(): boolean {
    return !!this.store?.feature_flag?.digital_gift_card_instore_redemption;
  }

  get showAmountEntry(): boolean {
    return this.uiUx ? this.instoreEnabled : this.useNow;
  }

  get canSwitchToInstore(): boolean {
    return !this.uiUx && this.instoreEnabled && !this.useNow;
  }

  get showUseNowCta(): boolean {
    return this.uiUx
      ? this.instoreEnabled && !!this.store?.feature_flag?.stand_alone_gift
      : this.useNow;
  }

  get showOrderNowCta(): boolean {
    return this.uiUx
      ? !this.instoreEnabled && !!this.store?.feature_flag?.stand_alone_gift
      : !this.useNow;
  }

  useFullBalance() {
    if (this.balance > 0) {
      this.redeemAmount = this.balance;
    }
  }

  redeem() {

    const dialogRef = this.dialog.open(RedeemConfirmationDialogComponent, {
      disableClose: true,
      data: {
        amount: this.redeemAmount
      }
    });

    dialogRef.afterClosed().subscribe(r => {
      if (r == 1) {
        this.isLoading = true;
        this.cdr.markForCheck();
        this.orderService.redeemOfferItem(this.hash, this.offerId, this.redeemAmount, this.storeId).subscribe({
          next: redeemHistory => {
            this.router.navigate([this.hash, 'my-offers', this.offerId, 'redeem', redeemHistory['id'], 'status']);
          },
          error: () => {
            this.isLoading = false;
            this.cdr.markForCheck();
          }
        });
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goBack() {
    window.history.back()
  }

  orderNow() {
    this.isLoading = true;
    this.cdr.markForCheck();
    this.orderService.createTempOrderWithPhone(this.store.url_slug, this.offerItem.offer_order.phone_number).subscribe({
      next: response => {
        this.router.navigate(['order', response['order_hash'], 'store', response['url_slug']]);
        this.orderHash = response['order_hash'];
        this.useNowGift(this.orderHash);
      },
      error: () => {
        this.isLoading = false;
        this.cdr.markForCheck();
      }
    });
  }

  useNowGift(e) {
    this.orderService.useGiftOrder(e).subscribe(res => {
      // console.log('33333333333333', res);
    });
  }


  scrollTo(el:HTMLElement){
    el.scrollIntoView()
  }

}
